// src/components/layout/Sidebar.tsx
import React from 'react';
import * as S from './Sidebar.styles';
import { menuItems } from './sidebar.data';
import MenuItem from './MenuItem';

const Sidebar: React.FC<{ isSidebarOpen: boolean }> = ({ isSidebarOpen }) => (
  <S.SidebarContainer isOpen={isSidebarOpen}>
    <S.LogoContainer isOpen={isSidebarOpen}>
      <S.LogoText isOpen={isSidebarOpen}>Etiquetado envases</S.LogoText>
      <S.LogoInitials isOpen={isSidebarOpen}>EV</S.LogoInitials>
    </S.LogoContainer>
    <S.NavList>
      {menuItems.map((item) => (
        <MenuItem key={item.path} item={item} isSidebarOpen={isSidebarOpen} />
      ))}
    </S.NavList>
  </S.SidebarContainer>
);

export default Sidebar;
